import React, { useState, useEffect } from 'react';
import styles from './Desktop.module.scss';
import './styles.css';
import strings from '../../../../../../globalization';
import { withRouter } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import moment from 'moment';
import PermitsHeader from '../../../../../../components/PermitsHeader';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import dimensions from '../../../../../../util/dimensions-util';
import { customStyles } from './customStyles';
import TextInput from '../../../../../../components/TextInput';
import DateRangeSelectionModal from '../../../VehicleEntryExitMovement/views/Desktop/DateRangeSelectionModal';
import {
  DATE_SELECTION_MODES,
  formatPeriodDisplayLabel,
} from '../../../VehicleEntryExitMovement/dateUtils';
import {
  AGENCY_REPORT_TABS,
  handleReportTabClick,
} from '../../../shared/reportTabs';
import Button from '../../../../../../components/Button';

import calendarBlue from '../../../../../../assets/images/calendar-blue-icon/image.png';
import downloadIcon from '../../../../../../assets/images/download-icon/download-icon.png';

import SannaLogo from '../../../../../../components/SannaLogo';

const { vw: widthConstant, vh: heightConstant } = dimensions;

const Desktop = props => {
  const {
    onClick,
    onChange,
    statuses,
    selectedStatus,
    selectedDropDownStatus,
    searchText,
    dates,
    startDate,
    endDate,
    perPage,
    permitList,
    startTime,
    endTime,
    totalCount,
    selectedType,
    dateSelectionMode,
    selectedYear,
    periodSelectionType,
  } = props;
  console.log('vehicle list', permitList);
  console.log('selected type:', selectedStatus);

  const defaultCellStyle = {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.5,
    whiteSpace: 'normal',
  };

  const formatDateTime = value =>
    value ? moment(value).format('DD/MM/YYYY HH:mm') : '-';

  const formatStatus = value =>
    value ? String(value).replace(/_/g, ' ') : '-';

  const formatValue = value =>
    value !== null && value !== undefined && value !== '' ? value : '-';

  const getTimestampHeader = () =>
    permitList && permitList[0]?.requestType === 1
      ? 'Exit timestamp'
      : permitList && permitList[0]?.requestType === 0
        ? 'Entry timestamp'
        : `${selectedType} timestamp`;

  const vehicleColumnDefs = [
    {
      headerName: getTimestampHeader(),
      field: 'createdDate',
      headerClass: styles.rowHeader,
      width: 210 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatDateTime(params.value),
    },
    {
      headerName: 'Permit reference ID',
      field: 'permitReferenceId',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Vehicle Registration Number',
      field: 'vehicleRegistrationNumber',
      headerClass: styles.rowHeader,
      width: 300 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Vehicle Owner Name',
      field: 'vehicleOwnerName',
      headerClass: styles.rowHeader,
      width: 300 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Gate',
      field: 'gateName',
      headerClass: styles.rowHeader,
      width: 230 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatValue(params.value),
    },
    {
      headerName: 'Credits',
      field: 'numberOfPasses',
      headerClass: styles.rowHeader,
      width: 130 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatValue(params.value),
    },
    {
      headerName: 'Reconciliation Status',
      field: 'reconciliationStatus',
      headerClass: styles.rowHeader,
      width: 220 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatStatus(params.value),
    },
  ];

  const personColumnDefs = [
    {
      headerName: getTimestampHeader(),
      field: 'createdDate',
      headerClass: styles.rowHeader,
      width: 210 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatDateTime(params.value),
    },
    {
      headerName: 'Permit reference ID',
      field: 'permitReferenceId',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Person Name',
      field: 'name',
      headerClass: styles.rowHeader,
      width: 300 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
    },
    {
      headerName: 'Person RFID',
      field: 'personRFID',
      headerClass: styles.rowHeader,
      width: 320 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatValue(params.value),
    },
    {
      headerName: 'Credits',
      field: 'numberOfPasses',
      headerClass: styles.rowHeader,
      width: 130 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatValue(params.value),
    },
    {
      headerName: 'Reconciliation Status',
      field: 'reconciliationStatus',
      headerClass: styles.rowHeader,
      width: 240 * widthConstant,
      flex: 1,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatStatus(params.value),
    },
  ];

  const [showDateModal, setShowDateModal] = useState(false);

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = params => {
    setGridApi(params.api);
    onChange('gridAPI', params.api);
  };
  const updateTable = () => {
    onChange('updateTable', null);
  };

  useEffect(() => {
    console.log(gridApi);
    if (gridApi && totalCount > 10) {
      console.log('changing to normal');
      gridApi.setDomLayout('normal');
    } else if (gridApi) {
      console.log('changing to autoHeight');
      gridApi.setDomLayout('autoHeight');
    }
  }, [totalCount]);

  useEffect(() => {
    console.log(gridApi);
    updateTable();
  }, [gridApi, startDate, endDate, startTime, endTime, selectedStatus, dateSelectionMode]);

  const onTabClick = id => {
    handleReportTabClick(id, onClick);
  };

  const isTodayMode = dateSelectionMode === DATE_SELECTION_MODES.TODAY;

  const getSelectedRangeLabel = () =>
    formatPeriodDisplayLabel({
      dateSelectionMode,
      dates,
      startDate,
      endDate,
      startTime,
      endTime,
    }) || strings.ADMIN.dateRange;

  const handleApplyDateSelection = selection => {
    onChange('applyDateSelection', selection);
  };

  const rowStyle = { border: 'none', cursor: 'pointer' };
  const getRowStyle = params => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: '#f6f6f6', border: 'none' };
    }
  };

  const handleClear = () => {
    setShowDateModal(false);
    onClick('clearFilters');
  };
  const handleInput = text => {
    onChange('search', text);
  };
  const handleSelect = name => {
    onChange('statusChange', name);
  };
  const handleButtonClick = () => {
    onClick('apply');
  };

  const getColumns = () => {
    if (selectedStatus === 'vehicle') {
      return vehicleColumnDefs;
    } else {
      return personColumnDefs;
    }
  };
  return (
    <div className={styles.agencyContainer}>
      <PermitsHeader
        title={
          selectedStatus === 'vehicle' ? 'Vehicle Movement' : 'Person Movement'
        }
        onTabClick={onTabClick}
        tabs={AGENCY_REPORT_TABS}
        activeTab={selectedStatus === 'vehicle' ? 1 : 2}
      />
      <div className={styles.bodyContainer}>
        <div className={styles.header}>
          <div className={styles.left}>
            <div className={styles.agencyNameDropdown}>
              <Select
                options={statuses}
                getOptionLabel={option => option.displayName}
                getOptionValue={option => option.id}
                placeholder={'Select type'}
                styles={customStyles}
                value={statuses.filter(
                  option => option?.id === selectedDropDownStatus?.id,
                )}
                onChange={handleSelect}
              />
            </div>
            <button
              type="button"
              className={styles.selectedRangeChip}
              onClick={() => setShowDateModal(true)}
              aria-label="Change date range">
              <span className={styles.selectedRangeType}>
                {isTodayMode ? 'Today' : 'Period'}
              </span>
              <span className={styles.selectedRangeValue}>
                {getSelectedRangeLabel()}
              </span>
              <img
                src={calendarBlue}
                className={styles.selectedRangeIcon}
                alt=""
              />
            </button>
            <DateRangeSelectionModal
              isOpen={showDateModal}
              onClose={() => setShowDateModal(false)}
              onApply={handleApplyDateSelection}
              dateSelectionMode={dateSelectionMode}
              selectedYear={selectedYear}
              periodSelectionType={periodSelectionType}
              startDate={startDate}
              endDate={endDate}
              dates={dates}
              startTime={startTime}
              endTime={endTime}
            />
          </div>
          <div className={styles.right}>
            <div className={styles.inputSearch}>
              <TextInput
                onChange={handleInput}
                isEdit={true}
                type={'text'}
                value={searchText}
                inputStyle={styles.inputText}
                showSeacrh={true}
                placeholder="Search"
              />
            </div>
            <div onClick={handleClear} className={styles.clearLabel}>
              {strings.ADMIN.clear}
            </div>
            <Button
              onClick={handleButtonClick}
              label={strings.ADMIN.apply}
              className={styles.applyBtn}></Button>
            <div>
              {permitList && permitList.length > 0 && !isTodayMode? (
                <img
                  className={styles.downloadIcon}
                  onClick={() => onClick('loadCSV')}
                  src={downloadIcon}
                  alt="icon"
                />
              ) : null}
            </div>
          </div>
        </div>
        <div
          className={[
            'ag-theme-balham vehicleMovementTable',
            styles.tableWrapper,
            totalCount > 10
              ? styles.tableWrapperNormal
              : styles.tableWrapperAutoHeight,
          ].join(' ')}>
          <AgGridReact
            rowStyle={rowStyle}
            getRowStyle={getRowStyle}
            rowHoverHighlight={true}
            columnDefs={getColumns()}
            rowHeight={60 * heightConstant}
            headerHeight={60 * heightConstant}
            defaultColDef={{
              sortable: true,
              resizable: true,
              wrapText: true,
              cellStyle: defaultCellStyle,
            }}
            rowClass={styles.gridRowClass}
            pagination={true}
            rowModelType={'infinite'}
            paginationPageSize={perPage}
            onGridReady={onGridReady}
            cacheBlockSize={perPage}
            domLayout="autoHeight"></AgGridReact>
        </div>
        {/* <div className={styles.bottomLabel}>
          Showing {filterAgencies.length}
        </div> */}
      </div>
      <div className={styles.SannaLogo}>
        <SannaLogo />
      </div>
    </div>
  );
};
export default withRouter(Desktop);
